import React, { useMemo } from 'react';
import NavigationModel from '../../../../components/CustomNavigation/NavigationModel';
import {croTypeNames } from '../../../../utils/employeeTypes';
import { isSameUserType } from '../../../../utils/helperFunction';

const IncomeForecaseNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const cred = localStorage.getItem('cred');
  const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const role = cred ? JSON.parse(cred)?.profile?.role : null;
  const loginedUserType = useMemo(() => {
    const cro = isSameUserType({ roleArray: croTypeNames, role: role });
    return cro ? 'CRO' : 'PM' || 'CRM';
  }, [role]);

  let redirectUrl;
  if (loginedUserType === 'CRO') {
    redirectUrl = `${phpNavigationUrl}/income/cro_income_forecast/${userId}/${currentYear}/${currentMonth}/-1/-1/`;
  } else {
    redirectUrl = `${phpNavigationUrl}/income/cro_income_forecast/-1/${currentYear}/${currentMonth}/-1/-1/`;
  }
  return <NavigationModel redirectUrl={redirectUrl} title="Fee Transfer" navigationTo={'Old Portal'} />;
};

export default IncomeForecaseNavigation;
